/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';

const WORD_LIMIT = 50;

/**
 * ExpandableContent allows for blocks of text content to be collapsed
 * and expanded.
 */
export default class ExpandableContent extends Component {
  // Component versioning
  @tracked visualStyle = 'v1';

  expandableContent = '';
  isExpanded = false;

  @computed('content')
  get processedContent() {
    let synopsis = '';
    let isExpandable = false;

    if (this.content) {
      let textAsArray = this.content.split(' ');
      isExpandable = textAsArray.length > WORD_LIMIT;
      let synopsisArray = textAsArray.slice(0, WORD_LIMIT);
      synopsis = synopsisArray.join(' ');
    }

    return { synopsis, isExpandable };
  }

  @alias('processedContent.synopsis')
  synopsis;

  @alias('processedContent.isExpandable')
  isExpandable;

  @action
  readMore() {
    this.toggleProperty('isExpanded');
  }
}
